import { z } from "zod";
export const productBarcodeInfo = z.object({
    id: z.string().uuid(),
    productId: z.string().uuid(),
    gtin: z.string(),
    barcodeType: z.string().nullable(),
    isPrimary: z.boolean(),
    isActive: z.boolean(),
    createdAt: z.string().datetime(),
});
export const createProductBarcodeRequest = z.object({
    gtin: z.string().min(1).max(128),
    barcodeType: z.string().max(64).nullish(),
    isPrimary: z.boolean().default(false),
});
export const productBarcodesListResponse = z.object({ items: z.array(productBarcodeInfo) });
//# sourceMappingURL=product-barcodes.schemas.js.map